<template>
  <header class="app-header" :style="{ backgroundColor: headerBgColor }">
    <div class="header-left">
      <router-link to="/groups" @click="handleLogoClick">
        <img
          alt="Vue logo"
          class="logo"
          src=".././assets/mutuus-logo.svg"
          width="125"
          height="125"
          style="cursor: pointer"
        />
      </router-link>
    </div>
    <div class="header-right">
      <div class="session-button" @click="toggleUserMenu">
        <span class="session-text">Sesión Iniciada</span>
        <div class="user-avatar">U</div>
      </div>
      <div v-if="showUserMenu" class="user-menu">
        <div class="user-info">
          <span class="user-name">Usuario</span>
        </div>
        <button @click="handleLogout" class="logout-link">Logout</button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { computed, ref } from 'vue'
import { useBulkLoadStore } from '../stores/bulkLoad'
import { STORAGE_KEY } from '../utils/constants'
import { WebEnvironmentConfigService } from '../services/env-config.service'

const router = useRouter()
const bulkLoadStore = useBulkLoadStore()
const showUserMenu = ref(false)
const envConfigService = new WebEnvironmentConfigService()
const environment = ref('')
envConfigService
  .getEnvironmentName()
  .then((env) => {
    environment.value = env || ''
  })
  .catch(() => {
    environment.value = ''
  })

const handleLogoClick = () => {
  bulkLoadStore.setData([])
  localStorage.removeItem(STORAGE_KEY)
}

const toggleUserMenu = () => {
  showUserMenu.value = !showUserMenu.value
}

const handleLogout = () => {
  localStorage.removeItem('apiKey')
  router.push('/')
}

const headerBgColor = computed(() => {
  console.log('Current environment:', environment.value)
  if (environment.value === 'production') return '#CAE1B8'
  return '#ffffff'
})
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');

.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 80px;
}

.header-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 40px;
}

.tabs-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0px;
  height: 57px;
  gap: 4px;
}

.tab {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 4px;
  width: 185px;
  height: 57px;
  background: #ffffff;
  border-bottom: 5px solid transparent;
  border-radius: 0px;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 140%;
  text-align: center;
  color: #2b2a2a;
  white-space: nowrap;
}

.tab.active {
  font-weight: 700 !important;
  border-bottom: 5px solid #003896 !important;
}

.tab:hover {
  background-color: #f8f9fa;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
  position: relative;
}

.session-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 16px;
  width: 225px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 40px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.session-button:hover {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}

.session-text {
  width: 161px;
  height: 19px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 130%;
  text-align: center;
  color: #000000;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #27ae60;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
}

.user-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  border-radius: 12px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  min-width: 200px;
  z-index: 1001;
}

.user-info {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e4e4;
}

.user-name {
  font-size: 16px;
  color: #555;
  font-weight: 600;
}

.logout-link {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 0;
  width: 100%;
  text-align: left;
  transition: color 0.2s;
}

.logout-link:hover {
  color: #c82333;
}

.header-left .logo {
  cursor: pointer;
}

.header-left .logo:hover,
.header-left .logo:active,
.header-left .logo:focus {
  outline: none;
  border: none;
  background: none;
  box-shadow: none;
  text-decoration: none;
  filter: none;
}

.header-left a {
  text-decoration: none;
}

.header-left a:focus,
.header-left a:active,
.header-left a:hover {
  outline: none;
  border: none;
  background: none;
  box-shadow: none;
  text-decoration: none;
}

.content-area {
  padding: 20px;
  width: 100%;
  margin: 20px auto;
  box-sizing: border-box;
  flex-grow: 1;
  padding-top: 100px;
}
</style>
